export default __webpack_public_path__ + "static/media/Terninger.b1cf8e7c.svg";